import { EntrySingletonPageShared } from '../../EntrySingletonPageShared.ts';
import '../../css/style.scss';
import './colonistRushTimer.scss';
import { UIWHeaderController } from '../ui_html/header/UIWHeaderController.ts';
import { UISidebarController } from '../ui_html/sidebar/UISidebarController.ts';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { sendColonistRushTimerPlayed, sendColonistRushTimerStarted } from './colonistRushTimerAnalytics.ts';
import { TimeUtils } from '@colonist/utils';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
const MIN_FRAME_WIDTH = 400;
const MIN_FRAME_HEIGHT = 900;
class EntryColonistRushTimer extends EntryShared {
    async init() {
        EntryShared.initializeAudio();
        await EntryShared.initializeEntry();
        const headerController = new UIWHeaderController();
        new UISidebarController();
        EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController);
        this.trackTimerStarted();
        this.trackTimeOnPage();
        this.scaleTimerToFit();
        this.setupMobileHeaderNavigation();
    }
    // eslint-disable-next-line class-methods-use-this
    setupMobileHeaderNavigation() {
        const backButton = document.getElementById('timer-mobile-header-back-button');
        const logo = document.getElementById('timer-mobile-header-logo');
        if (backButton != null) setElementOnClick(backButton, ()=>navigateToPage('/'));
        if (logo != null) setElementOnClick(logo, ()=>navigateToPage('/'));
    }
    // eslint-disable-next-line class-methods-use-this
    scaleTimerToFit() {
        const timerFrame = document.getElementById('timer-frame');
        const timerPage = timerFrame === null || timerFrame === void 0 ? void 0 : timerFrame.parentElement;
        if (timerFrame == null) return;
        if (timerPage == null) return;
        const updateScale = ()=>{
            const availableWidth = timerPage.clientWidth;
            const availableHeight = timerPage.clientHeight;
            const frameWidth = Math.max(availableWidth, MIN_FRAME_WIDTH);
            const frameHeight = Math.max(availableHeight, MIN_FRAME_HEIGHT);
            const scaleForWidth = availableWidth / frameWidth;
            const scaleForHeight = availableHeight / frameHeight;
            const scale = Math.min(scaleForWidth, scaleForHeight);
            timerFrame.style.width = `${frameWidth}px`;
            timerFrame.style.height = `${frameHeight}px`;
            timerFrame.style.setProperty('--timer-scale', String(scale));
        };
        new ResizeObserver(updateScale).observe(timerPage);
        updateScale();
    }
    trackTimerStarted() {
        const timerFrame = document.getElementById('timer-frame');
        window.addEventListener('blur', ()=>{
            if (this.hasSentStarted) return;
            if (document.activeElement != timerFrame) return;
            this.hasSentStarted = true;
            sendColonistRushTimerStarted();
        });
    }
    trackTimeOnPage() {
        window.addEventListener('pagehide', ()=>this.trackTimePlayed());
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState == 'hidden') this.trackTimePlayed();
        });
    }
    trackTimePlayed() {
        if (this.hasSentPlayed) return;
        this.hasSentPlayed = true;
        const secondsOnPage = (Date.now() - this.pageLoadTime) / TimeUtils.MILLISECONDS;
        sendColonistRushTimerPlayed(secondsOnPage);
    }
    constructor(){
        super(), this.pageLoadTime = Date.now(), this.hasSentStarted = false, this.hasSentPlayed = false;
        void this.init();
    }
}
new EntryColonistRushTimer();
